import React from 'react';

const Actors = () => {
  console.log('Actors');
  return (
    <div>Actors</div>
  );
};

export default Actors;
